<template>

    <m-edit1/>

    <m-single-product-302 v-bind='{...{"productLink":null,"relatedProducts":false,"digitalShoppingCartText":"\u0627\u0641\u0632\u0648\u062f\u0646 \u0628\u0647 \u0633\u0628\u062f \u062e\u0631\u06cc\u062f","physicalShoppingCartText":"\u0627\u0641\u0632\u0648\u062f\u0646 \u0628\u0647 \u0633\u0628\u062f \u062e\u0631\u06cc\u062f","relatedProductsText":"\u0645\u062d\u0635\u0648\u0644\u0627\u062a \u0645\u0631\u062a\u0628\u0637","relatedProductPrice":true,"smsBox":false},...{}}' :style='""' class="my-5 container " >
                <template #default>default   </template>
                </m-single-product-302>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSingleProduct302 from '@moeinmdn/miw-alpha-components/src/package/Product/Single/SingleProduct302';

export default {
    name: 'HomeView',
    components: {mEdit1, mSingleProduct302 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
